import { render, staticRenderFns } from "./CheckboxWrap.vue?vue&type=template&id=d0a752be&"
import script from "./CheckboxWrap.vue?vue&type=script&lang=js&"
export * from "./CheckboxWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CheckboxWrap.vue"
export default component.exports